module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat5#_idTextAnchor000"
    }
  }, [_vm._v("What Exactly Is This Book?"), _c('span', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body--Left-Justify-"
  }, [_vm._v("First… "), _c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("Look at ")]), _c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("this!!")]), _vm._v(" "), _c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("Look at it!!")]), _vm._v(" It’s a cookbook, recipe guide, instruction manual. I wanted to make this book more than just something you pick up from time to time to check out a new recipe—more of a guide into how I make the plant-based meat you see on Sauce Stache. I wanted to give you the insight to how I come up with the flavors, smells, and textures of my recipes, so you can experiment and make your own"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("creations.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body--Left-Justify-"
  }, [_vm._v("When reading this book and working your way through these “recipes,” please don’t follow them step by step, don’t use exactly the same seasonings, sauces, and ingredients that I use. Try something new… "), _c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("Experiment!")]), _vm._v(" Maybe make something once to see how it comes out, but then next time replace the protein with something completely different—you might be surprised what happens. I want you to find your flavor, find the satisfying texture you’re looking for in plant-based meat. For everyone that is different! I realized the things that I enjoyed about the tastes and textures of meat are completely different from what you might enjoy, and that’s why this cookbook (guide) will walk you through, not only how to make the creations I make in my kitchen, but exactly what each ingredient is doing there. You might find clues on how you can substitute something to make a recipe even better, you might figure out a way to make something taste exactly like you remember it, you might find a way to nail that perfect taste that’ll make anyone’s mouth water. I hope you find this cookbook enjoyable on many levels. I hope it feeds, not just your appetite for good food, but also your appetite for"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("c"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("reativity.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Image-Bottom-full-bleed",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "src": "image/seitanbacon.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b266fbae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MakingVeganMeat-7.vue
// module id = 81
// module chunks = 0